import { EuiAccordion, EuiCard, EuiFlexGroup, EuiFlexItem, EuiIcon, EuiSpacer, EuiTitle, EuiToken, htmlIdGenerator } from '@elastic/eui';
import React, { useEffect, useMemo, useState } from 'react';
import { CreateFecha, CreateFechaMoment } from '../../../../shared/utils/fecha';
import { FechasBloqueParcialScreen } from './FechasBloqueoParcial/screen';
import './styles.css';

interface Props {
  data: any;
  fechasBloqueoParcial:any;
  saveLockApp(stateApp:any):any;
  saveFechasBloqueoParcial(fechasData:any):any;
}

const ConfiguracionAppScreen = (props: Props) => {
  let { data, fechasBloqueoParcial, saveLockApp, saveFechasBloqueoParcial} = props;

  const [estado, setEstado] = useState<any>(true);

  useEffect(()=>{
    setEstado(data);
  },[data])

  const ChangeStateApp = (newState:any) =>{
    saveLockApp && saveLockApp(newState);
  }

  const getStatesApp = useMemo(() =>{
    return(
      <EuiFlexGroup>
        <EuiFlexItem>
          <EuiCard
              className={`cardState-unlock ${estado===false?'cardState-unlock-selected':''}`}
              icon={<EuiIcon size="xxl" type='lockOpen'/>}
              title={`Desbloqueada`}
              description="No hay ningún tipo de restricción."
              onClick={() => ChangeStateApp(false)}
          />
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiCard
              className={`cardState-parcial-lock ${estado===null?'cardState-parcial-lock-selected':''}`}
              icon={<EuiIcon size="xxl" type='lock'/>}
              title={`Parcialmente Bloqueada`}
              description={<p>{`Se bloquea la creación, edición, eliminación y desvalidación de partes dentro del `}<strong>{`rango de fechas establecido en la configuración de fechas para el bloqueo parcial`}</strong> </p>}
              onClick={() => ChangeStateApp(null)}
          />
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiCard
              className={`cardState-lock ${estado===true?'cardState-lock-selected':''}`}
              icon={<EuiIcon size="xxl" type='lock'/>}
              title={`Bloqueada`}
              description="Se bloquea la creación, edición, eliminación y desvalidación de partes."
              onClick={() => ChangeStateApp(true)}
          />
        </EuiFlexItem>
    </EuiFlexGroup>
    )
  },[estado])

  const getStateIconApp = useMemo(() => {
  const type = estado === false ? 'lockOpen' : 'lock';
  const color = estado === true ? "#ffa48c" : (estado === false ? "#caffff" : "#f9e382")
   return (<EuiToken iconType={type} size='l' shape="square" color={color}/>)
  },[estado])

  const getDatesParcialBlockIcon = useMemo(()=> (<EuiToken iconType='calendar' size='l' shape="square" color='#f9e382'/>),[])
  const getFechasBloqueoParcial = useMemo(()=>{
    if(fechasBloqueoParcial!==undefined){
      let fIni, fFin;
      fIni = fechasBloqueoParcial.fechaBloqueoParcialDesde!==null ? CreateFecha(fechasBloqueoParcial.fechaBloqueoParcialDesde): '';
      fFin = fechasBloqueoParcial.fechaBloqueoParcialHasta!==null ? CreateFecha(fechasBloqueoParcial.fechaBloqueoParcialHasta): '';
      return fIni==='' ? `(Sin Configurar)` : `(${fIni} - ${fFin})`
    }
  },[fechasBloqueoParcial])

  return (
    <EuiFlexGroup direction='column'>
      <EuiFlexItem>
      <EuiFlexGroup className='configurationApp-accordion'>
        <EuiFlexItem>
          <EuiAccordion
            id={htmlIdGenerator()()}
            arrowDisplay="right"
            initialIsOpen={false}
            buttonContent={<EuiFlexGroup>
              <EuiFlexItem grow={false} style={{justifyContent: 'center'}}>
              {getStateIconApp}
              </EuiFlexItem>
              <EuiFlexItem>
              <EuiTitle size="s">
                <h3>{`Estado de la aplicación`}</h3>
              </EuiTitle>
              </EuiFlexItem>
            </EuiFlexGroup>}
            paddingSize="m"
          >
            {getStatesApp}
          </EuiAccordion>
        </EuiFlexItem>
      </EuiFlexGroup>
      </EuiFlexItem>
      <EuiSpacer size='s'/>
      <EuiFlexItem>
      <EuiFlexGroup className='configurationApp-accordion'>
        <EuiFlexItem>
          <EuiAccordion
            id={htmlIdGenerator()()}
            arrowDisplay="right"
            initialIsOpen={false}
            buttonContent={<EuiFlexGroup>
              <EuiFlexItem grow={false} style={{justifyContent: 'center'}}>
              {getDatesParcialBlockIcon}
              </EuiFlexItem>
              <EuiFlexItem>
              <EuiTitle size="s">
                <h3>{`Fechas para el bloqueo parcial `}<strong>{getFechasBloqueoParcial}</strong></h3>
              </EuiTitle>
              </EuiFlexItem>
            </EuiFlexGroup>}
            paddingSize="m">
            <FechasBloqueParcialScreen data={fechasBloqueoParcial} saveData={saveFechasBloqueoParcial}/>
          </EuiAccordion>
        </EuiFlexItem>
      </EuiFlexGroup>
      </EuiFlexItem>
  </EuiFlexGroup>
  );
};

export default ConfiguracionAppScreen;
